import React, {useState, useMemo, useEffect} from "react";
import ssmlCheck from "ssml-check-core";
import TextArea from "./TextArea";
import ValidateButton from "./ValidateButton";
import Results from "./Results";
import PlatformSelector, {Platform} from "./PlatformSelector";
import Analytics from "analytics";
import {checkReservedCharacters, minifyXml, stringifyError} from "../utils/validation";

// @ts-ignore
import * as vkbeautify from 'vkbeautify';
// @ts-ignore
import mixpanelPlugin from '@analytics/mixpanel'
// @ts-ignore
import googleTagManager from '@analytics/google-tag-manager'

window.Buffer = window.Buffer || require("buffer").Buffer;

const SSMLLint = () => {
    const [ssmlText, setSsmlText] = useState('');
    const [resultText, setResultText] = useState('')
    const [isValid, setIsValid] = useState(false)
    const [positionToHighlight, setPositionToHighlight] = useState(-1)
    const [platform, setPlatform] = useState<Platform>('all')

    const analytics = useMemo(() => {
        const plugins = [];
        if (process.env.REACT_APP_GTM_ID) {
            plugins.push(googleTagManager({ containerId: process.env.REACT_APP_GTM_ID }));
        }
        if (process.env.REACT_APP_MIXPANEL_TOKEN) {
            plugins.push(mixpanelPlugin({ token: process.env.REACT_APP_MIXPANEL_TOKEN }));
        }
        return Analytics({ app: 'SSMLLint', plugins });
    }, []);

    useEffect(() => {
        analytics.page();
    }, [analytics]);

    const clearText = () => {
        setSsmlText("")
        setResultText("")
    }

    const SSMLCheck = (prettifiedText: string) => {
        ssmlCheck.check(prettifiedText, {platform, getPositions: true})
            .then((errors: any) => {
                if (errors) {
                    let results = ""
                    results += stringifyError(errors[0], prettifiedText)
                    setResultText(results)
                    setIsValid(false)
                    setPositionToHighlight(errors[0].position)
                } else {
                    if (platform === 'google') {
                        const reservedCharError = checkReservedCharacters(prettifiedText);
                        if (reservedCharError) {
                            setResultText(reservedCharError);
                            setIsValid(false);
                            setPositionToHighlight(-1);
                            return;
                        }
                    }
                    setResultText('Valid SSML')
                    setIsValid(true)
                    setPositionToHighlight(-1)
                }
            });
    }

    const ValidateText = (text: string) => {
        const minified = minifyXml(text);
        const prettifiedText = vkbeautify.xml(minified);
        setSsmlText((ssmlText) => {
            SSMLCheck(prettifiedText)
            return prettifiedText;
        })
        analytics.track('validate SSML', {
            item: ssmlText,
            prettifiedText: prettifiedText,
            isValid: isValid,
            errorMessage: resultText,
            platform: platform
        })
    };

    return (
        <div className="w-full max-w-4xl mx-auto">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-3">
                <PlatformSelector platform={platform} onPlatformChange={setPlatform} />
                <div className="flex gap-2">
                    <ValidateButton validateText={() => ValidateText(ssmlText)} />
                    <button
                        className="border border-border hover:bg-gray-50 text-muted font-medium px-5 py-2 rounded-lg transition-colors text-sm"
                        onClick={clearText}
                    >
                        Clear
                    </button>
                </div>
            </div>
            <div className="rounded-xl border border-border bg-surface shadow-card overflow-hidden">
                <TextArea ssmlText={ssmlText} onSsmlTextChange={setSsmlText} positionToHighlight={positionToHighlight} />
            </div>
            {resultText !== '' && <Results isValid={isValid} resultText={resultText} />}
        </div>
    )
}

export default SSMLLint
